<template>
  <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-position="top"
  >
    <el-dialog
        :visible="visible"
        :before-close="handleClose"
        :title="isEdit ? 'Edit Network Site' : 'Create Network Site'"
        width="94%"
    >

      <el-form-item label="URL" prop="url">
        <el-input v-model="form.url"/>
      </el-form-item>

      <el-form-item label="Category" prop="category_id">
        <el-select v-model="form.category_id" filterable>
          <el-option
              v-for="category in networkCategories.data"
              :key="category.id"
              :label="category.name"
              :value="category.id"
          />
        </el-select>
      </el-form-item>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary" @click="onSubmit">Save</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import modalMixin from '@/mixins/modalMixin'

const defaultFormValues = {
  id: null,
  url: '',
  category_id: null
}

export default {
  name: 'AddEditSiteDialog',
  mixins: [modalMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: { ...defaultFormValues },
      originFormValues: { ...defaultFormValues },
      rules: {
        url: [
          { required: true, message: 'Please input URL', trigger: 'change' }
        ],
        category_id: [
          { required: true, message: 'Please select Campaign', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState('network', [
      'networkCategories'
    ]),
    ...mapState('sites', [
      'activeNetworkSite'
    ]),
    isEdit() {
      return !!(this.activeNetworkSite?.id)
    },
    isFormChanged() {
      return JSON.stringify(this.originFormValues) !== JSON.stringify(this.form)
    }
  },
  watch: {
    activeNetworkSite() {
      if (this.isEdit) {
        this.fillForm()
      } else {
        this.setActiveNetworkSite(null)
        this.resetForm()
        this.originFormValues = { ...this.form }
      }
    }
  },
  mounted() {
    this.fetchNetworkCategories()
  },
  methods: {
    ...mapActions('network', [
      'fetchNetworkCategories'
    ]),
    ...mapMutations('sites', [
      'setActiveNetworkSite'
    ]),
    ...mapActions('sites', [
      'createNetworkSite',
      'updateNetworkSite'
    ]),
    fillForm() {
      this.form = { ...this.activeNetworkSite }
      this.originFormValues = { ...this.form }
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.isEdit) {
            await this.updateNetworkSite(this.form)
          } else {
            await this.createNetworkSite(this.form)
          }
          this.$emit('refetch-data')
          this.closeModal()
        }
      })
    },
    handleClose() {
      this.$_modalMixin_closeConfirmation(this.closeModal, this.isFormChanged)
    },
    closeModal() {
      this.resetForm()
      this.setActiveNetworkSite(null)
      this.$emit('close')
    },
    resetForm() {
      this.form = { ...defaultFormValues }
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep .el-dialog {
  max-width: 500px;
}

::v-deep .el-dialog__body {
  margin-bottom: -20px;
}
</style>
